module.exports = __webpack_public_path__ + "static/media/eh.828b1298.jpeg";